import ForceVerifyEmail from "../../pages/ForceVerifyEmail"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { useContext, useEffect } from "react"
import { UserCtx } from "../../context/userContext"
import { useAuthenticatedUser } from "../../hooks/useAuthenticatedUser"

const PrivateRouteEmailVerified = () => {
  const { user } = useContext(UserCtx)
  const location = useLocation()
  const navigate = useNavigate()
  const coachRedirect = localStorage.getItem("coachRedirect")
  const memberRedirect = localStorage.getItem("memberRedirect")
  const authenticatedUser = useAuthenticatedUser(user)

  const redirectPath =
    user.activeProfile === "coach" ? coachRedirect : memberRedirect

  useEffect(() => {
    if (user.emailVerified) {
      localStorage.removeItem("hasSentVerification")
      if (redirectPath) {
        navigate(redirectPath)
        localStorage.removeItem("coachRedirect")
        localStorage.removeItem("memberRedirect")
      }
    } else {
      if (!coachRedirect && !memberRedirect) {
        localStorage.setItem(
          "coachRedirect",
          `${location.pathname}${location.search}`
        )
        localStorage.setItem(
          "memberRedirect",
          `${location.pathname}${location.search}`
        )
      }
    }
  }, [user.emailVerified, location, navigate, redirectPath])

  if (!user.emailVerified && authenticatedUser) {
    return <ForceVerifyEmail />
  }

  return <Outlet />
}

export default PrivateRouteEmailVerified
